export default (socketClient) => {
    let observersMap = new Map();
    function unsubscribe({type, key}) {
        let observerMapKey = key ? `${type}_${key}` : type;
        let observer = observersMap.get(observerMapKey);
        if (observer) observer.unsubscribe();
        observersMap.delete(observerMapKey);
    }

    function subscribe(type, {path = '', params = {}, key}) {
        let observerMapKey = key ? `${type}_${key}` : type;
        if (observersMap.has(observerMapKey)) {
            let observer = observersMap.get(observerMapKey);
            observer.update(params);
        }
        else if (path) {
            let newObserver = socketClient.subscribe(path, params);
            newObserver.onUpdate(({error, data}) => {
                if (error) {
                    this.dispatch({
                        type: `${type}_ERROR`,
                        error
                    });
                }
                else {
                    this.dispatch({
                        type: `${type}_DATA`,
                        payload: data
                    });
                }
            });
            observersMap.set(observerMapKey, newObserver);
        }
    }

    return store => next => action => {
        if (action.subscribe || action.unsubscribe) {
            if (action.subscribe) subscribe.call(store, action.type, action.subscribe);
            else if (action.unsubscribe) unsubscribe.call(store, action.unsubscribe);
        }
        next(action);
    };
};